import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";

import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

class ScheduleBuilderOnBoarding extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            showButton: false
        }

        this.handleSlid = this.handleSlid.bind(this);
    }

    handleSlid(selectedIndex) {
        if (selectedIndex === 2) {
            this.setState({showButton: true});
        }
    }

    render() {
        let component = null;

        if (this.props.show) {
            component =
                <Modal show={this.props.show}
                       onHide={this.props.hideModal}
                       aria-labelledby="schedule-builder-onboarding-modal"
                       size="lg"
                       centered>
                    <Modal.Header closeButton>
                        <Modal.Title as="h2" className="h3" id="schedule-builder-onboarding-modal">New Schedule Builder at a glance</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Carousel className="carousel-circle-indicators carousel-gray-arrows"
                                  onSlid={this.handleSlid}
                                  wrap={false}
                                  interval={null}>
                            <Carousel.Item>
                                <figure role="group" className="text-center">
                                    <a href="/plan/assets/images/sb-onboard-s1-v3@2x.png"
                                       title="Open for larger view in new window"
                                       target="_blank">
                                        <img srcSet="/plan/assets/images/sb-onboard-s1-v3.png 1x, /plan/assets/images/sb-onboard-s1-v3@2x.png 2x"
                                             src="/plan/assets/images/sb-onboard-s1-v3.png"
                                             alt="diagram showing Schedule Builder features and what's new"
                                             aria-describedby="sb-onboard-s1"
                                             className="border"
                                             style={{maxWidth: '100%', height: 'auto'}} /></a>
                                    <figcaption id="sb-onboard-s1" className="sr-only">
                                        <h3>New Schedule Builder at a glance - Part 1</h3>
                                        <p>Your planned courses are used to generate schedule options. You can explore different schedule
                                            options by deselecting courses and sections, then selecting the "Update Schedule Options" button.</p>
                                        <p>If your section has an alert, there is a message to explain why your planned section was
                                            excluded and broader schedule options are provided.</p>
                                        <p>Add filters to include specific types of sections, and/or to exclude sections that meet on days
                                            and time you can't attend the class.</p>
                                    </figcaption>
                                </figure>
                            </Carousel.Item>
                            <Carousel.Item>
                                <figure role="group" className="text-center">
                                    <a href="/plan/assets/images/sb-onboard-s2@2x.png"
                                       title="Open for larger view in new window"
                                       target="_blank">
                                        <img srcSet="/plan/assets/images/sb-onboard-s2.png 1x, /plan/assets/images/sb-onboard-s2@2x.png 2x"
                                             src="/plan/assets/images/sb-onboard-s2.png"
                                             alt="diagram showing Schedule Builder features and what's new"
                                             aria-describedby="sb-onboard-s2"
                                             className="border"
                                             style={{maxWidth: '100%', height: 'auto'}} /></a>
                                    <figcaption id="sb-onboard-s2" className="sr-only">
                                        <h3>New Schedule Builder at a glance - Part 2</h3>
                                        <p>Pinning a schedule allows you to save your favorite schedule options in Schedule Builder without
                                            affecting your plan.</p>
                                        <p>'View details' will give more schedule details and more actions you can take with this schedule, like
                                            add it to your plan or pin it!</p>
                                    </figcaption>
                                </figure>
                            </Carousel.Item>
                            <Carousel.Item>
                                <figure role="group" className="text-center">
                                    <a href="/plan/assets/images/sb-onboard-s3-v3@2x.png"
                                       title="Open for larger view in new window"
                                       target="_blank">
                                        <img srcSet="/plan/assets/images/sb-onboard-s3-v3.png 1x, /plan/assets/images/sb-onboard-s3-v3@2x.png 2x"
                                             src="/plan/assets/images/sb-onboard-s3-v3.png"
                                             alt="diagram showing Schedule Builder features and what's new"
                                             aria-describedby="sb-onboard-s3"
                                             className="border"
                                             style={{maxWidth: '100%', height: 'auto', marginTop: '26px', marginBottom: '27px'}} /></a>
                                    <figcaption id="sb-onboard-s3" className="sr-only">
                                        <h3>New Schedule Builder at a glance - Part 3</h3>
                                        <p>Schedule Details view shows the list of sections with the meeting location, seat status, and
                                            enrollment restriction (if any).</p>
                                        <p>If you like the schedule option, you can add it your plan to prepare to register for those sections.</p>
                                    </figcaption>
                                </figure>
                            </Carousel.Item>
                        </Carousel>
                        <p className="mt-3 mb-0 text-center">
                            <a href="https://itconnect.uw.edu/learn/tools/myplan-academic-planner/schedule-builder/" target="_blank">Get more how-tos
                                and troubleshooting tips</a> for Schedule builder.
                        </p>
                    </Modal.Body>
                    <Modal.Footer className={classnames("justify-content-center", {'d-none': !this.state.showButton})}>
                        <Button variant="secondary" onClick={this.props.hideModal}>
                            OK, I got it
                        </Button>
                    </Modal.Footer>
                </Modal>;
        }

        return component;
    }
}

ScheduleBuilderOnBoarding.propTypes = {
    show: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired
}

export default ScheduleBuilderOnBoarding;